import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnZM: CultureInfo = {
  name: 'en-ZM',
  displayName: 'English (Zambia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-ZM',
  parent: CultureInfoEn
};
